import axios from "axios";
import { Config } from "../../../core/config/config";
import { processLoadOptions } from "@/core/helper/datasource-query-helper";
import { LoadOptions } from "devextreme/data";
const GATEWAY_URL = `${Config.VITE_APP_GATEWAY_URL}/api/account/admin/integration-log`;

const eticaretServiceRetry=['ProductBarcode','Product','SaleChannel','SaleMove'];
const retryTenantIds=['4','6','7'];

export const accountIntegrationLogService = {
    getSupplierLogList: async function (loadOptions: any) {
            const params = processLoadOptions(loadOptions);
            return axios.get(`${GATEWAY_URL}`, {
                params
            }).then((response) => {
                return response.data;
            });
        },
        getSupplierLogDetailList: async function (loadOptions: LoadOptions, retailerCode: string | null = null, retailerId: string) {
            try 
            {
                const params = processLoadOptions(loadOptions);
                if (retailerCode) {
                    params.RetailerCode = retailerCode;
                }
               
                const response = await axios.get(`${GATEWAY_URL}/details`, { params });
                const queryResult = response.data.data ?? [];
        
                if (queryResult.length > 0) 
                    {
                    const grouped = queryResult.reduce((acc: any, job: any) => {
                        (acc[job.jobName] = acc[job.jobName] || []).push(job);
                        return acc;
                    }, {});
        
                    const latestJobsPerGroup = (Object.values(grouped) as any[][]).map(group =>
                        group.sort((a, b) => new Date(b.processDate).getTime() - new Date(a.processDate).getTime())[0]
                    );
                    latestJobsPerGroup
                        .filter(job => retryTenantIds.includes(retailerId) && job.layer === "ODS" && job.log =='END' && job.errorMessage!=null && job.errorMessage!='' && job.errorMessage!='NULL')
                        .forEach(job => {
                            job.isRetry = true;
                            job.isRetryEticaret = false;
                        });

                        latestJobsPerGroup
                        .filter(job =>retryTenantIds.includes(retailerId) && job.layer === "ODS" && job.log=='END' && eticaretServiceRetry.includes(job.jobName) && job.errorMessage!=null && job.errorMessage!='')
                        .forEach(job => {
                            job.isRetry = false;
                            job.isRetryEticaret = true;
                        });
                }
                return {
                    data: queryResult,
                    totalCount: response.data.totalCount ?? 10
                };
            } 
            catch (error) {
                console.error("Error fetching supplier log details:", error);
                throw error;
            }
        }
}